import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  doc,
  getDoc,
} from "firebase/firestore";
import "./UsdtManagement.css";
import { useNavigate } from "react-router-dom";

function UsimamiziUsdt() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [address, setAddress] = useState("");
  const [network, setNetwork] = useState("");
  const [message, setMessage] = useState("");
  const [savedList, setSavedList] = useState([]);

  // ===============================
  // 🔐 CHECK SECURITY DOC IPO (bila swali)
  // ===============================
  const checkSecurity = async (user) => {
    const ref = doc(db, "security", user);
    const snap = await getDoc(ref);

    if (!snap.exists()) {
      navigate("/settings", { replace: true });
      return;
    }
  };

  // ===============================
  // 📥 LOAD SAVED ADDRESSES
  // ===============================
  const fetchSaved = async (user) => {
    const q = query(
      collection(db, "user_usdt_withdraw"),
      where("username", "==", user)
    );
    const snap = await getDocs(q);
    setSavedList(snap.docs.map((d) => d.data()));
  };

  // ===============================
  // 🚀 INIT
  // ===============================
  useEffect(() => {
    const u = localStorage.getItem("username");
    if (!u) {
      navigate("/login", { replace: true });
      return;
    }
    setUsername(u);
    checkSecurity(u);
    fetchSaved(u);
  }, [navigate]);

  // ===============================
  // ➕ SAVE ADDRESS
  // ===============================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!network || !address) {
      setMessage("Jaza taarifa zote");
      return;
    }

    const exists = savedList.some(
      (d) => d.network.toLowerCase() === network.toLowerCase()
    );
    if (exists) {
      setMessage("USDT address tayari ipo kwa mtandao huu");
      return;
    }

    await addDoc(collection(db, "user_usdt_withdraw"), {
      username,
      network,
      address,
    });

    setMessage("USDT address imehifadhiwa ✔");
    setAddress("");
    setNetwork("");
    fetchSaved(username);
  };

  // ===============================
  // 🔒 MASK ADDRESS
  // ===============================
  const mask = (addr) =>
    addr.length < 10
      ? addr
      : `${addr.slice(0, 6)} **** ${addr.slice(-6)};`

  return (
    <div className="usdt-wrapper">
      <div className="usdt-header">ONGEZA USDT ADDRESS</div>

      {/* SAVED LIST */}
      {savedList.map((d, i) => (
        <div key={i} className="usdt-card">
          <div className="usdt-left">
            <div className="usdt-ball"></div>
            <div>
              <div className="usdt-network">{d.network}</div>
              <div className="usdt-sub">USDT wallet</div>
            </div>
          </div>

          <div className="usdt-right">
            <span className="usdt-address">{mask(d.address)}</span>
          </div>
        </div>
      ))}

      {/* ADD FORM */}
      {savedList.length < 1 && (
        <form onSubmit={handleSubmit} className="usdt-add">
          <select
            className="usdt-input"
            value={network}
            onChange={(e) => setNetwork(e.target.value)}
          >
            <option value="">Chagua mtandao</option>
            <option value="TRC20">TRC20</option>
          </select>

          <input
            className="usdt-input"
            placeholder="USDT Address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />

          <button className="usdt-btn">Hifadhi USDT Address</button>
        </form>
      )}

      {message && <div className="usdt-msg">{message}</div>}

      <div className="usdt-footer">
        Kikomo: USDT address 1 tu kwa kila akaunti
      </div>
    </div>
  );
}

export default UsimamiziUsdt;